import {Typography} from "@mui/material";
import React from "react";

export const Title = ({ children }) => {
    return <Typography sx={{fontWeight: "bold"}}>{children}</Typography>;
}